<template>
    <div class="body bg-gradient-primary">

        <div class="container">

            <!-- Outer Row -->
            <div class="row justify-content-center">

                <div class="col-md-5">

                    <div class="card o-hidden border-0 shadow-lg my-5">
                        <div class="card-body p-0">
                            <router-view />
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'auth-layout'
    }

</script>

<style scoped>
    .body {
        height: 100vh;
    }

</style>
